import React from 'react';
import {
  RESERVE_SUBNAV_ANALYZE,
  RESERVE_SUBNAV_RESERVATIONS,
  RESERVE_SUBNAV_SETTINGS,
  RESERVE_SUBNAV_TYPE,
  resolveReservePath,
} from '@go-client/routes';
import { Property } from '@go-shared/types/property';
import { camelToSentenceCase } from '@go-shared/lib/string';
import { BubbleNavigation } from '../BubbleUI';

interface ReserveSubNavigationProps {
  active: RESERVE_SUBNAV_TYPE;
  property: Property;
}

export default function ReserveSubNavigation(props: ReserveSubNavigationProps) {
  const navItems: RESERVE_SUBNAV_TYPE[] = RESERVE_SUBNAV_RESERVATIONS.includes(props.active)
    ? RESERVE_SUBNAV_RESERVATIONS
    : RESERVE_SUBNAV_ANALYZE.includes(props.active)
      ? RESERVE_SUBNAV_ANALYZE
      : RESERVE_SUBNAV_SETTINGS.includes(props.active)
        ? RESERVE_SUBNAV_SETTINGS
        : [];

  return (
    <BubbleNavigation
      appearance="squared"
      items={navItems.map(ni => ({
        name: camelToSentenceCase(ni),
        to: resolveReservePath(props.property._id, ni),
        active: props.active === ni,
        variant: 'turquoise',
      }))}
    />
  );
}
